import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AnalyticsService } from '@core/services/analytics/analytics.service';
import { ValidationService } from '@core/services/api/http/validation.service';
import { Masks, Patterns } from '@global/enums';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { MaskitoOptions, MaskitoElementPredicate, MaskitoMask, MaskitoElement } from '@maskito/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'qb-de-promotional-code-modal',
  templateUrl: './promotional-code-modal.component.html',
  styleUrls: ['./promotional-code-modal.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QbPromotionalCodeModalComponent implements OnInit {
  @Input() promoCode?: string;

  readonly promoCodeMask: MaskitoOptions = {
    mask: Masks.PROMO_CODE,
  };

  readonly maskitoPredicate: MaskitoElementPredicate = async el => {
    return (el.querySelector('input') || el.querySelector('textarea') || el) as MaskitoElement;
  };

  protected readonly validationService: ValidationService = inject(ValidationService);
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);

  promoCodeError?: string;
  // promoCodeMask = Masks.PROMO_CODE;
  promoCodeReplacerMask = Masks.PROMO_CODE_REPLACER;

  promoCodeForm: FormGroup<{
    promoCode: FormControl<string>;
  }> = new FormGroup({
    promoCode: new FormControl<string>(undefined, {
      validators: [Validators.required, Validators.pattern(Patterns.PROMOCODE)],
      nonNullable: true,
    }),
  });

  closeIconAriaLabel = 'ACCESSIBILITY.MODAL.CLOSE';

  serviceLoading?: Observable<boolean>;

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly cdr: ChangeDetectorRef,
    private readonly translateService: TranslateService
  ) {
    this.promoCodeForm.controls.promoCode.valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.promoCodeError = undefined;
      const control = this.promoCodeForm.controls.promoCode;

      if (control.dirty && control.errors) {
        if (control.errors['pattern']) {
          this.promoCodeError = this.translateService.instant('OFFER.INPUTS.PROMO_CODE.PATTERN-ERROR');
        }
      }

      this.cdr.markForCheck();
    });
  }

  ngOnInit(): void {
    this.promoCodeForm.controls.promoCode.setValue(this.promoCode);
    this.analyticsService.sendPopupView('promo code');
    this.promoCodeForm.controls.promoCode.valueChanges
      .pipe(
        map(value => (value ? value.toUpperCase() : value)),
        distinctUntilChanged()
      )
      .subscribe(upperValue => {
        this.promoCodeForm.controls.promoCode.setValue(upperValue, { emitEvent: false });
      });
  }

  onButtonClicked(): void {
    this.modalCtrl.dismiss(this.promoCodeForm.controls.promoCode.value);
  }

  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
